// Lista država koje se mogu izabrati za pretplatnika.
// Koristi se u formama za izmjenu i unos novog korisnika.
// Nova država se dodaje samo ovdje.

export const DRZAVE = [
  'Bosna i Hercegovina',
  'Srbija',
  'Crna Gora',
  'Hrvatska',
  'Slovenija',
  'Sjeverna Makedonija',
  'Albanija',
  'Bugarska',
  'Rumunija',
  'Švicarska',
];

export const DEFAULT_DRZAVA = 'Bosna i Hercegovina';

// Opcije za select: standardna lista + trenutna vrijednost ako nije na listi
// (npr. stari unos "BiH"), da se pri snimanju ne izgubi bez znanja admina.
export function opcijeDrzava(trenutna) {
  if (trenutna && !DRZAVE.includes(trenutna)) {
    return [...DRZAVE, trenutna];
  }
  return DRZAVE;
}

export const jeStandardnaDrzava = (drzava) => DRZAVE.includes(drzava);
